import { ToastContainer } from 'react-toastify';
import { Router } from 'react-router-dom';
import { PullToRefresh, PullDownContent, ReleaseContent, RefreshContent } from 'react-js-pull-to-refresh';
import './assets/plugins/nucleo/css/nucleo.css';
import '@fortawesome/fontawesome-free/css/all.min.css';
import './assets/scss/main.scss';
import 'react-toastify/dist/ReactToastify.css';
import 'react-confirm-alert/src/react-confirm-alert.css';
import 'rc-time-picker/assets/index.css';
import 'react-datepicker/dist/react-datepicker.css';

import Routes from './routes';
import history from './history';

import { AuthProvider } from './contexts/AuthContext';
import useCheckMobileScreen from './hooks/useCheckMobileScreen';
import { enableSwipeBack } from './helpers/swipeBack';
import { initDeepLinks } from './helpers/deepLink';
import { useEffect } from 'react';
import log from 'loglevel';

log.setLevel((process.env.REACT_APP_LOG_LEVEL as log.LogLevelDesc) ?? 'warn');

const PULL_TO_REFRESH_ENABLED = false;

const App = () => {
  const { isMobile } = useCheckMobileScreen();
  useEffect(() => {
    const hostname = window.location.hostname;
    if (hostname.includes('beta-app.arb.systems')) {
      document.title = 'ARB Systems - Beta';
    }
  }, []);

  useEffect(() => {
    void enableSwipeBack();
  }, []);

  useEffect(() => {
    void initDeepLinks();
  }, []);

  const refreshPage = async () => {
    window.location.reload();
    return;
  };

  return (
    <AuthProvider>
      <Router history={history}>
        <div style={{ paddingTop: 'env(safe-area-inset-top)' }}>
          {isMobile && (
            <div
              style={{
                position: 'fixed',
                top: 0,
                left: 0,
                right: 0,
                height: 'env(safe-area-inset-top)',
                backgroundColor: '#fafafb',
                zIndex: 1029,
              }}
            />
          )}
          <ToastContainer autoClose={4000} style={{ paddingTop: 'env(safe-area-inset-top)' }} />
          {isMobile && PULL_TO_REFRESH_ENABLED ? (
            <PullToRefresh
              pullDownContent={<PullDownContent />}
              releaseContent={<ReleaseContent />}
              refreshContent={<RefreshContent />}
              pullDownThreshold={200}
              onRefresh={() => refreshPage()}
              triggerHeight={500}
              backgroundColor="white"
              startInvisible={true}
            >
              <Routes />
            </PullToRefresh>
          ) : (
            <>
              <Routes />
            </>
          )}
        </div>
      </Router>
    </AuthProvider>
  );
};

export default App;
